// https://github.com/hotwired/turbo/issues/37#issuecomment-1169195154

let scrollSelector = null;

const freeze = () => {
  // @ts-ignore
  window.Turbo.navigator.currentVisit.scrolled = true;
  document.removeEventListener('turbo:render', freeze);

  if (scrollSelector) {
    const el = document.querySelector(scrollSelector);

    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }

    scrollSelector = null;
  }
};

export const freezeScrollOnNextRender = (selector = null) => {
  scrollSelector = selector;
  document.addEventListener('turbo:render', freeze);
};
